// import React, { useState, useEffect, useRef } from "react";
// import Select from 'react-select';
// import { State, City } from 'country-state-city';
// import "../../styles/account.css";
// import { FiPhone, FiX } from "react-icons/fi";
// import { getWithoutTokenAPI, getWithTokenAPI, ImageUpload, putWithTokenAPI } from "../../util/Api";
// import { masterdata_list, students_profile, update_profile } from "../../util/Apiendpoits";
// import { useSelector } from "react-redux";
// import { SafeToast } from "../Toast/ShowToast";
// import ReactCrop from 'react-image-crop';

// const AccountsComponent = () => {
//     const [logo, setLogo] = useState(null);
//     const [thumbnail, setThumbnail] = useState(null);
//     const [institution, setInstitution] = useState("Shankar IAS Academy");
//     const [themeColor, setThemeColor] = useState("#900307");
//     const [description, setDescription] = useState("Founded In 2004 By Mr. Shankar D.");
//     const [phone, setPhone] = useState("+91 88888 88888");
//     const { token, roleType, userId } = useSelector((state) => state.auth);

//     const [stateOptions, setStateOptions] = useState([]);
//     const [selectedState, setSelectedState] = useState(null);
//     const [districtOptions, setDistrictOptions] = useState([]);
//     const [selectedDistrict, setSelectedDistrict] = useState(null);
//     const [examOptions, setExamOptions] = useState([]);

//     const [selectedImage, setSelectedImage] = useState(null);
//     const [showCropModal, setShowCropModal] = useState(false);
//     const [completedCrop, setCompletedCrop] = useState(null);
//     const [crop, setCrop] = useState({ aspect: 1 });
//     const [uploadType, setUploadType] = useState(""); // logo | thumbnail
//     const imgRef = useRef(null);

//     const [selectedExams, setSelectedExams] = useState([]);
//     const [showAddInput, setShowAddInput] = useState(false);
//     const [newExamValue, setNewExamValue] = useState("");
//     const [accountNo, setAccountNo] = useState("15252524172732");
//     const [ifsc, setIfsc] = useState("IND9154548SDF");
//     const bankOptions = [
//         { value: "Indian Bank", label: "Indian Bank" },
//         { value: "HDFC Bank", label: "HDFC Bank" },
//     ];
//     const [selectedBank, setSelectedBank] = useState(null);

//     const fetchAccountDetails = async () => {

//         try {
//             const res = await getWithTokenAPI(
//                 token,
//                 `${students_profile}${userId}`
//             );

//             if (res?.statusCode === 200) {
//                 const Profile = res.data; // ✅ FIX 1
//                 setLogo(Profile?.logo);
//                 setPhone(Profile.phoneNumber);
//                 setSelectedDistrict(Profile.district);
//                 setSelectedState(Profile.state);
//                 setThumbnail(Profile.thumbnail);
//                 setAccountNo(Profile.bankaccountNumber);
//                 setSelectedBank(Profile.bank);
//                 setIfsc(Profile.ifsc);
//                 setDescription(Profile.discription);
//                 setInstitution(Profile.nameofInstitution)
//                 setThemeColor(Profile.color)
//                 const selectedExams = examOptions.filter(option =>
//                     Profile.exams.includes(option.value)
//                 );

//                 setSelectedExams(selectedExams);

//             }
//         } catch (error) {
//             console.error("Error fetching account details:", error);
//         }
//     };
//     const fetchExamOptions = async () => {
//         try {
//             const response = await getWithoutTokenAPI("/masterdata/list-all");
//             if (response.statusCode === 200) {
//                 const options = response.data
//                     .filter(item => item.type === "examType" && item.status === "active")
//                     .map(item => ({ value: item.code, label: item.value }));

//                 setExamOptions(options);
//             }
//         } catch (error) {
//             console.error("Error fetching exam options:", error);
//         }
//     };

//     useEffect(() => {
//         fetchAccountDetails();
//         fetchExamOptions();
//     }, []);

//     // Load States
//     useEffect(() => {
//         const indianStates = State.getStatesOfCountry("IN");
//         const formattedStates = indianStates.map(state => ({
//             value: state.isoCode,
//             label: state.name
//         }));
//         setStateOptions(formattedStates);

//         const defaultState = formattedStates.find(state => state.label === "Tamil Nadu");
//         if (defaultState) {
//             setSelectedState(defaultState);
//             loadDistricts(defaultState.value);
//         }
//     }, []);

//     const loadDistricts = (stateCode) => {
//         const cities = City.getCitiesOfState("IN", stateCode);
//         const formatted = cities.map(city => ({ value: city.name, label: city.name }));
//         setDistrictOptions(formatted);
//         const defaultDist = formatted.find(d => d.label === "Chennai");
//         if (defaultDist) setSelectedDistrict(defaultDist);
//     };

//     const handleStateChange = (option) => {
//         setSelectedState(option);
//         setSelectedDistrict(null);
//         if (option) loadDistricts(option.value);
//     };

//     // Select Styles
//     const customStyles = {
//         control: (base) => ({
//             ...base,
//             border: "none",
//             boxShadow: "0 4px 12px rgba(0,0,0,0.05)",
//             borderRadius: "10px",
//             minHeight: "45px",
//         }),

//         /* Selected chip */
//         multiValue: (base) => ({
//             ...base,
//             backgroundColor: "#1a73e8",
//             borderRadius: "12px",
//             padding: "2px 4px",
//         }),

//         multiValueLabel: (base) => ({
//             ...base,
//             color: "#fff",
//             fontWeight: 500,
//             paddingRight: "4px",
//         }),

//         /* ✅ ONLY close (×) button show */
//         multiValueRemove: (base) => ({
//             ...base,
//             color: "#fff",
//             borderRadius: "50%",
//             padding: "2px",
//             cursor: "pointer",
//             ":hover": {
//                 backgroundColor: "#dc3545",
//                 color: "#fff",
//             },
//         }),

//         /* ❌ Right side clear (X) remove */
//         clearIndicator: () => ({
//             display: "none",
//         }),

//         indicatorSeparator: () => ({
//             display: "none",
//         }),
//     };



//     const handleExamsChange = (selected) => {
//         if (selected?.some(item => item.value === "ADD_NEW")) {
//             setShowAddInput(true);
//         } else {
//             setSelectedExams(selected || []);
//         }
//     };

//     const handleAddExam = () => {
//         if (!newExamValue.trim()) return;
//         const newOption = { value: newExamValue.toUpperCase(), label: newExamValue };
//         setExamOptions([...examOptions, newOption]);
//         setSelectedExams([...selectedExams, newOption]);
//         setNewExamValue("");
//         setShowAddInput(false);
//     };

//     const handleImageChange = (e, type) => {
//         const file = e.target.files[0];
//         if (!file) return;

//         if (!file.type.startsWith("image/")) {
//             SafeToast.error("Please select an image file");
//             return;
//         }

//         if (file.size > 5 * 1024 * 1024) {
//             SafeToast.error("Image size should be less than 5MB");
//             return;
//         }

//         const reader = new FileReader();
//         reader.onload = () => {
//             setSelectedImage(reader.result);
//             setUploadType(type); // ⭐ logo / thumbnail
//             setShowCropModal(true);
//             setCompletedCrop(null);
//         };
//         reader.readAsDataURL(file);
//     };


//     const onImageLoad = (img) => {
//         imgRef.current = img;
//     };

//     const handleCropComplete = async () => {
//         if (!imgRef.current || !completedCrop) {
//             SafeToast.error("No crop data available");
//             return;
//         }

//         const image = imgRef.current;
//         const canvas = document.createElement("canvas");

//         const scaleX = image.naturalWidth / image.width;
//         const scaleY = image.naturalHeight / image.height;

//         canvas.width = completedCrop.width * scaleX;
//         canvas.height = completedCrop.height * scaleY;

//         const ctx = canvas.getContext("2d");

//         ctx.drawImage(
//             image,
//             completedCrop.x * scaleX,
//             completedCrop.y * scaleY,
//             completedCrop.width * scaleX,
//             completedCrop.height * scaleY,
//             0,
//             0,
//             canvas.width,
//             canvas.height
//         );

//         canvas.toBlob((blob) => {
//             if (!blob) {
//                 SafeToast.error("Crop failed");
//                 return;
//             }
//             uploadImage(blob);
//         }, "image/jpeg", 0.95);
//     };

//     const uploadImage = async (blob) => {
//         const formData = new FormData();
//         formData.append("files", blob, `${uploadType}.jpg`);

//         try {
//             const res = await ImageUpload(
//                 `/upload_image?userId=${userId}&type=${roleType}`,
//                 formData,
//                 true
//             );

//             if (res?.statusCode === 200) {
//                 const imageUrl = res.data?.[0]?.fileUrl;

//                 if (!imageUrl) {
//                     SafeToast.error("Image uploaded but URL missing");
//                     return;
//                 }

//                 // ⭐ Set based on type
//                 if (uploadType === "logo") {
//                     setLogo(imageUrl);
//                 } else if (uploadType === "thumbnail") {
//                     setThumbnail(imageUrl);
//                 }

//                 SafeToast.success("Image uploaded successfully");
//             } else {
//                 SafeToast.error(res?.message || "Upload failed");
//             }
//         } catch (err) {
//             SafeToast.error("Upload error");
//         } finally {
//             handleCancelCrop();
//         }
//     };


//     const handleCancelCrop = () => {
//         setShowCropModal(false);
//         setSelectedImage(null);
//         setCrop({ aspect: 1 });
//         setCompletedCrop(null);
//         setUploadType("");
//     };


//     useEffect(() => {
//         const isAnyModalOpen = showCropModal || selectedImage

//         if (isAnyModalOpen) {
//             document.body.style.overflow = "hidden";
//         } else {
//             document.body.style.overflow = "auto";
//         }

//         return () => {
//             document.body.style.overflow = "auto";
//         };
//     }, [showCropModal, selectedImage]);


//     const HandleUpdate = async () => {
//         const examCodes = selectedExams.map(exam => exam.value);

//         try {
//             const payload = {
//                 phoneNumber: phone,
//                 district: selectedDistrict.value,
//                 state: selectedState.value,
//                 bankaccountNumber: accountNo,
//                 bank: selectedBank,
//                 ifsc: ifsc,
//                 discription: description,
//                 nameofInstitution: institution,
//                 color: themeColor,
//                 logo: logo,
//                 thumbnail: thumbnail,
//                 exams: examCodes, // ⭐ IMPORTANT
//             };

//             console.log("Update payload:", payload);

//             const res = await putWithTokenAPI(
//                 token,
//                 `${update_profile}/${userId}`,
//                 payload
//             );

//             if (res?.statusCode === 200) {
//                 SafeToast.success("Profile updated successfully");
//                 fetchAccountDetails();
//             } else {
//                 SafeToast.error(res?.message || "Update failed");
//             }
//         } catch (error) {
//             console.error("Update error:", error);
//             SafeToast.error("Something went wrong");
//         }
//     };

//     return (
//         <div className="account-container">
//             <div className="account-card-wrapper">

//                 {/* FORM SECTION */}
//                 <div className="form-grid-section">
//                     <div className="upload-row">
//                         <div className="upload-item">
//                             <div className="logo-preview-circle">
//                                 {logo ? <img src={logo} alt="logo" /> : <div className="placeholder">LOGO</div>}
//                                 <div className="label-overlay">LOGO</div>
//                             </div>
//                             <label className="change-link">Change
//                                 <input
//                                     type="file"
//                                     hidden
//                                     accept="image/*"
//                                     onChange={(e) => handleImageChange(e, "logo")}
//                                 />
//                             </label>
//                         </div>

//                         <div className="upload-item">
//                             <div className="thumb-preview-box">
//                                 {thumbnail ? <img src={thumbnail} alt="thumb" /> : <div className="placeholder">160x195</div>}
//                                 <div className="label-overlay">THUMBNAIL</div>
//                             </div>
//                             <label className="change-link">Change
//                                 <input
//                                     type="file"
//                                     hidden
//                                     accept="image/*"
//                                     onChange={(e) => handleImageChange(e, "thumbnail")}
//                                 />                            </label>
//                         </div>

//                         <div className="meta-inputs-container modern-glass-card">
//                             <div className="input-group">
//                                 <label className="modern-label">Institution Description</label>
//                                 <textarea
//                                     className="modern-textarea"
//                                     value={description}
//                                     onChange={(e) => setDescription(e.target.value)}
//                                     style={{ '--focus-color': themeColor }} // Dynamic glow
//                                     placeholder="Tell us about your institution..."
//                                 />
//                             </div>

//                             <div className="modern-color-section">
//                                 <label className="modern-label">Brand Identity</label>
//                                 <div className="modern-color-picker-pill">
//                                     <div className="color-visual">
//                                         <div className="color-circle" style={{ backgroundColor: themeColor }}>
//                                             <input
//                                                 type="color"
//                                                 value={themeColor}
//                                                 onChange={(e) => setThemeColor(e.target.value)}
//                                                 className="hidden-color-input"
//                                             />
//                                         </div>
//                                     </div>
//                                     <div className="color-info">
//                                         <span className="color-name">Theme Color</span>
//                                         <span className="color-hex">{themeColor}</span>
//                                     </div>
//                                     <div className="color-action-text">Change</div>
//                                 </div>
//                             </div>
//                         </div>
//                     </div>

//                     <div className="inputs-container">


//                         <div className="form-group">
//                             <label>Phone Number</label>
//                             <div className="input-box">
//                                 <span className="icon"><FiPhone /></span>
//                                 <input
//                                     placeholder="ex: +91 88888 88888"
//                                     value={phone}
//                                     type="tel"
//                                     onChange={(e) => setPhone(e.target.value)}
//                                     maxLength={10}
//                                 />
//                                 <button
//                                     className="otp-btn"

//                                 >
//                                     {"SEND OTP"}
//                                 </button>
//                             </div>

//                         </div>

//                         <div className="input-row">
//                             <div className="input-field">
//                                 <label>Institution Name</label>
//                                 <input type="text" value={institution} onChange={(e) => setInstitution(e.target.value)} />
//                             </div>
//                             <div className="input-field">
//                                 <label>State</label>
//                                 <Select styles={customStyles} options={stateOptions} value={selectedState} onChange={handleStateChange} />
//                             </div>
//                         </div>

//                         <div className="input-row">
//                             <div className="input-field">
//                                 <label>District</label>
//                                 <Select styles={customStyles} options={districtOptions} value={selectedDistrict} onChange={setSelectedDistrict} />
//                             </div>
//                             <div className="input-field">
//                                 <label>Exams</label>


//                                 {
//                                     !showAddInput &&
//                                     (
//                                         <Select
//                                             options={[...examOptions, { value: "ADD_NEW", label: "+ Add New" }]}

//                                             value={selectedExams}
//                                             onChange={handleExamsChange}
//                                             placeholder="Search and select exams..."
//                                             isMulti
//                                             isClearable
//                                             styles={customStyles}
//                                             isSearchable
//                                             closeMenuOnSelect={false}
//                                             className="react-select"
//                                         />
//                                     )
//                                 }

//                                 {showAddInput && (
//                                     <div >
//                                         <div className="input-field add-exam-row">

//                                             <input
//                                                 type="text"
//                                                 value={newExamValue}
//                                                 onChange={(e) => setNewExamValue(e.target.value)}
//                                                 placeholder="Enter new exam"
//                                             />

//                                             <button
//                                                 type="button"
//                                                 onClick={handleAddExam}
//                                                 className="add-btn"
//                                             >
//                                                 Add
//                                             </button>

//                                             <button
//                                                 type="button"
//                                                 onClick={() => {
//                                                     setShowAddInput(false);
//                                                     setNewExamValue("");
//                                                 }}
//                                                 className="close-btn"
//                                                 title="Close"
//                                             >
//                                                 ✕
//                                             </button>

//                                         </div>
//                                     </div>

//                                 )}

//                             </div>
//                         </div>

//                         <div className="input-row">
//                             <div className="input-field">
//                                 <label>Bank Account No</label>
//                                 <input type="text" value={accountNo} onChange={(e) => setAccountNo(e.target.value)} />
//                             </div>
//                             <div className="input-field">
//                                 <label>IFSC</label>
//                                 <input type="text" value={ifsc} onChange={(e) => setIfsc(e.target.value)} />
//                             </div>
//                         </div>

//                         <div className="input-row align-bottom">
//                             <div className="input-field">
//                                 <div className="input-field">
//                                     <label>Bank</label>
//                                     <Select
//                                         styles={customStyles}
//                                         options={bankOptions}
//                                         value={selectedBank}
//                                         onChange={setSelectedBank}
//                                         placeholder="Select Bank"
//                                     />
//                                 </div>

//                             </div>
//                             <div className="button-field"
//                                 onClick={HandleUpdate}
//                             >
//                                 <button className="btn-update">Update Action</button>
//                             </div>
//                         </div>
//                     </div>
//                 </div>

//                 {/* PREVIEW SECTION */}
//                 <div className="preview-sticky-section">
//                     <p className="preview-header">Preview</p>
//                     <div className="card-mockup" style={{ background: `linear-gradient(180deg, ${themeColor} 0%, #000 100%)` }}>
//                         <div className="card-thumb">
//                             {thumbnail && <img src={thumbnail} alt="thumb" />}
//                         </div>
//                         <div className="card-body">
//                             <div className="card-logo-box">
//                                 {logo ? <img src={logo} alt="logo" /> : <div className="logo-placeholder">L</div>}
//                             </div>
//                             <p className="card-tags">{selectedExams.map(e => e.label).join(" | ")}</p>
//                             <p className="card-candidates">2500+ Candidates</p>
//                             <div className="explore-pill">
//                                 <span>EXPLORE MORE</span>
//                                 <div className="arrow-circle" style={{ backgroundColor: themeColor }}>➜</div>
//                             </div>
//                             <h2 className="card-inst-name">{institution}</h2>
//                             <p className="card-footer-info">{description}</p>
//                             <p className="card-footer-info">{institution}</p>
//                         </div>
//                     </div>
//                 </div>
//             </div>


//             {showCropModal && selectedImage && (
//                 <div className="modal-overlay">
//                     <div className="crop-modal">
//                         <div className="modal-header">
//                             <h3>Crop Image</h3>
//                             <button onClick={handleCancelCrop}><FiX /></button>
//                         </div>
//                         <div className="modal-body">
//                             <div className="crop-container">
//                                 <ReactCrop
//                                     crop={crop}
//                                     onChange={setCrop}
//                                     onComplete={setCompletedCrop}
//                                     aspect={1}
//                                     circularCrop
//                                 >
//                                     <img
//                                         src={selectedImage}
//                                         onLoad={(e) => onImageLoad(e.target)}
//                                         alt="Crop"
//                                     />
//                                 </ReactCrop>
//                             </div>

//                             <div className="crop-actions">
//                                 <button
//                                     className="cancel-crop-btn"
//                                     onClick={handleCancelCrop}
//                                 >
//                                     Cancel
//                                 </button>
//                                 <button
//                                     className="apply-crop-btn"
//                                     onClick={handleCropComplete}
//                                     disabled={!completedCrop}
//                                 >
//                                     Apply Crop
//                                 </button>
//                             </div>
//                         </div>
//                     </div>
//                 </div>
//             )}

//         </div>
//     );
// };

// export default AccountsComponent;

import React, { useState, useEffect, useRef } from "react";
import Select from 'react-select';
import { State, City } from 'country-state-city';
import "../../styles/account.css";
import { FiCheck, FiPhone, FiX } from "react-icons/fi";
import { getWithoutTokenAPI, getWithTokenAPI, ImageUpload, postWithTokenAPI, putWithTokenAPI } from "../../util/Api";
import { masterdata_list, send_otp, students_profile, update_profile, verify_otp } from "../../util/Apiendpoits";
import { useDispatch, useSelector } from "react-redux";
import { SafeToast } from "../Toast/ShowToast";
import ReactCrop from 'react-image-crop';
import { FiArrowRight } from "react-icons/fi";
import { setProfileData } from "../../store/profileSlice";
import { InstitutionProfileSkeleton } from "../ReusableComponent/TableSkeleton";
const AccountsComponent = () => {
    const [profileData, setProfileDatas] = useState(null);
    const [loading, setLoading] = useState(true);

    const [logo, setLogo] = useState(null);
    const [thumbnail, setThumbnail] = useState(null);
    const [institution, setInstitution] = useState("Shankar IAS Academy");
    const [themeColor, setThemeColor] = useState("#900307");
    const [description, setDescription] = useState("Founded In 2004 By Mr. Shankar D.");
    const [phone, setPhone] = useState("+91 88888 88888");
    const [setOptbuttonshow, setsetOptbuttonshow] = useState(true)
    const { token, roleType, userId } = useSelector((state) => state.auth);
    const [stateOptions, setStateOptions] = useState([]);
    const [selectedState, setSelectedState] = useState(null);
    const [districtOptions, setDistrictOptions] = useState([]);
    const [selectedDistrict, setSelectedDistrict] = useState(null);
    const [examOptions, setExamOptions] = useState([]);
    console.log(examOptions, "examOptions--------------")
    const [selectedExams, setSelectedExams] = useState([]);
    console.log(selectedExams, 'selectedExams---------------')
    const [showOtpModal, setShowOtpModal] = useState(false);

    const [selectedImage, setSelectedImage] = useState(null);
    const [showCropModal, setShowCropModal] = useState(false);
    const [completedCrop, setCompletedCrop] = useState(null);
    const [crop, setCrop] = useState({
        unit: "%",
        width: 80,
        aspect: 1
    });

    const [uploadType, setUploadType] = useState(""); // logo | thumbnail
    const imgRef = useRef(null);
    const otpInputRefs = useRef([]);
    const [showAddInput, setShowAddInput] = useState(false);
    const [newExamValue, setNewExamValue] = useState("");
    const [accountNo, setAccountNo] = useState("15252524172732");
    const [ifsc, setIfsc] = useState("IND9154548SDF");
    const [isOtpVerified, setIsOtpVerified] = useState(false);

    const [selectedBank, setSelectedBank] = useState(null);

    const [isSendingOtp, setIsSendingOtp] = useState(false);
    const [otpCountdown, setOtpCountdown] = useState(0);
    const [otp, setOtp] = useState(["", "", "", ""]);
    const dispatch = useDispatch();

    const fetchInitialData = async () => {
        setLoading(true);
        try {
            // 1. Load states
            const indianStates = State.getStatesOfCountry("IN");
            const formattedStates = indianStates.map(state => ({
                value: state.isoCode,
                label: state.name
            }));
            setStateOptions(formattedStates);

            // 2. Fetch profile data
            const profileRes = await getWithTokenAPI(token, `${students_profile}${userId}`);
            if (profileRes?.statusCode === 200) {
                setProfileDatas(profileRes.data);
                setLogo(profileRes.data?.logo || null);
                setThumbnail(profileRes.data?.thumbnail || null);
                setPhone(profileRes.data?.phoneNumber || "");
                setAccountNo(profileRes.data?.bankaccountNumber || "");
                setIfsc(profileRes.data?.ifsc || "");
                setDescription(profileRes.data?.discription || "");
                setInstitution(profileRes.data?.nameofInstitution || "");
                setThemeColor(profileRes.data?.color || "#900307");
                setSelectedBank(profileRes.data?.bank || "");

            }

            // 3. Fetch exam options
            const examRes = await getWithoutTokenAPI("/masterdata/list-all");
            if (examRes.statusCode === 200) {
                const options = examRes.data
                    .filter(item => item.type === "examType" && item.status === "active")
                    .map(item => ({ value: item.code, label: item.value, id: item._id }));
                setExamOptions(options);
            }

        } catch (error) {
            console.error("Error fetching initial data:", error);
            SafeToast.error("Failed to load data");
        } finally {
            setLoading(false);
        }
    };

    // Set state and district after profile and options are loaded
    useEffect(() => {
        if (!profileData || !stateOptions.length) return;

        // Set selected state
        if (profileData.state) {
            const stateObj = stateOptions.find(option => option.value === profileData.state);
            if (stateObj) {
                setSelectedState(stateObj);
                // Load districts for this state
                loadDistricts(stateObj.value, profileData.district);
            }
        }
    }, [profileData, stateOptions]);

    // Set exams after exam options are loaded
    useEffect(() => {
        if (!profileData?.exams || !examOptions.length) return;

        // const selectedExamObjs = profileData.exams
        //     .map(examCode => examOptions.find(opt => opt.id === examCode))
        //     .filter(Boolean); 

        const selectedExams = examOptions.filter(opt =>
            profileData.exams.includes(opt.id)
        );

        setSelectedExams(selectedExams);
    }, [profileData, examOptions]);

    const loadDistricts = (stateCode, savedDistrict = null) => {
        const cities = City.getCitiesOfState("IN", stateCode);
        const formatted = cities.map(city => ({
            value: city.name,
            label: city.name
        }));
        setDistrictOptions(formatted);

        // Set saved district if available
        if (savedDistrict) {
            const districtObj = formatted.find(d => d.value === savedDistrict);
            setSelectedDistrict(districtObj || null);
        }
    };

    const handleStateChange = (option) => {
        setSelectedState(option);
        setSelectedDistrict(null);
        if (option) {
            loadDistricts(option.value);
        }
    };

    // Select Styles
    const customStyles = {
        control: (base) => ({
            ...base,
            border: "none",
            boxShadow: "0 4px 12px rgba(0,0,0,0.05)",
            borderRadius: "10px",
            minHeight: "45px",
        }),
        multiValue: (base) => ({
            ...base,
            backgroundColor: "#1a73e8",
            borderRadius: "12px",
            padding: "2px 4px",
        }),
        multiValueLabel: (base) => ({
            ...base,
            color: "#fff",
            fontWeight: 500,
            paddingRight: "4px",
        }),
        multiValueRemove: (base) => ({
            ...base,
            color: "#fff",
            borderRadius: "50%",
            padding: "5px",
            cursor: "pointer",
            ":hover": {
                backgroundColor: "#dc3545",
                color: "#fff",
            },
        }),
        clearIndicator: () => ({
            display: "none",
        }),
        indicatorSeparator: () => ({
            display: "none",
        }),
    };

    const handleExamsChange = (selected) => {
        if (selected?.some(item => item.value === "ADD_NEW")) {
            setShowAddInput(true);
        } else {
            setSelectedExams(selected || []);
        }
    };

    const handleAddExam = () => {
        if (!newExamValue.trim()) {
            SafeToast.error("Please enter exam name");
            return;
        }
        const newOption = {
            value: newExamValue.toUpperCase().replace(/\s+/g, '_'),
            label: newExamValue
        };
        setExamOptions([...examOptions, newOption]);
        setSelectedExams([...selectedExams, newOption]);
        setNewExamValue("");
        setShowAddInput(false);
    };

    const handleImageChange = (e, type) => {
        const file = e.target.files[0];
        if (!file) return;

        if (!file.type.startsWith("image/")) {
            SafeToast.error("Please select an image file");
            return;
        }

        if (file.size > 5 * 1024 * 1024) {
            SafeToast.error("Image size should be less than 5MB");
            return;
        }

        const reader = new FileReader();
        reader.onload = () => {
            setSelectedImage(reader.result);
            setUploadType(type);
            setShowCropModal(true);
            setCompletedCrop(null);
        };
        reader.readAsDataURL(file);
    };

    const onImageLoad = (img) => {
        imgRef.current = img;
    };

    const handleCropComplete = async () => {
        if (!imgRef.current || !completedCrop) {
            SafeToast.error("No crop data available");
            return;
        }

        const image = imgRef.current;
        const canvas = document.createElement("canvas");

        const scaleX = image.naturalWidth / image.width;
        const scaleY = image.naturalHeight / image.height;

        canvas.width = completedCrop.width * scaleX;
        canvas.height = completedCrop.height * scaleY;

        const ctx = canvas.getContext("2d");

        // ✅ Remove black background
        ctx.clearRect(0, 0, canvas.width, canvas.height);

        ctx.drawImage(
            image,
            completedCrop.x * scaleX,
            completedCrop.y * scaleY,
            completedCrop.width * scaleX,
            completedCrop.height * scaleY,
            0,
            0,
            canvas.width,
            canvas.height
        );

        canvas.toBlob((blob) => {
            if (!blob) {
                SafeToast.error("Crop failed");
                return;
            }
            uploadImage(blob);
        }, "image/png"); // ⭐ MUST
    };


    const uploadImage = async (blob) => {
        const formData = new FormData();
        formData.append("files", blob, `${uploadType}.jpg`);

        try {
            const res = await ImageUpload(
                `/upload_image?userId=${userId}&type=${roleType}`,
                formData,
                true
            );

            if (res?.statusCode === 200) {
                const imageUrl = res.data?.[0]?.fileUrl;

                if (!imageUrl) {
                    SafeToast.error("Image uploaded but URL missing");
                    return;
                }

                if (uploadType === "logo") {
                    setLogo(imageUrl);
                } else if (uploadType === "thumbnail") {
                    setThumbnail(imageUrl);
                }

                SafeToast.success("Image uploaded successfully");
            } else {
                SafeToast.error(res?.message || "Upload failed");
            }
        } catch (err) {
            SafeToast.error("Upload error");
        } finally {
            handleCancelCrop();
        }
    };

    const handleCancelCrop = () => {
        setShowCropModal(false);
        setSelectedImage(null);
        setCrop({ aspect: 1 });
        setCompletedCrop(null);
        setUploadType("");
    };

    useEffect(() => {
        if (showCropModal || selectedImage) {
            document.body.style.overflow = "hidden";
        } else {
            document.body.style.overflow = "auto";
        }

        return () => {
            document.body.style.overflow = "auto";
        };
    }, [showCropModal, selectedImage]);

    const HandleUpdate = async () => {
        if (!selectedState || !selectedDistrict) {
            SafeToast.error("Please select state and district");
            return;
        }
        const examCodes = selectedExams.map(exam => exam.id);
        try {
            const payload = {
                phoneNumber: phone,
                district: selectedDistrict.value,
                state: selectedState.value,
                bankaccountNumber: accountNo,
                bank: selectedBank || "",
                ifsc: ifsc,
                discription: description,
                nameofInstitution: institution,
                color: themeColor,
                logo: logo,
                thumbnail: thumbnail,
                exams: examCodes,
            };

            const res = await putWithTokenAPI(
                token,
                `${update_profile}/${userId}`,
                payload
            );

            if (res?.statusCode === 200) {
                SafeToast.success("Profile updated successfully");
                fetchInitialData();
                setsetOptbuttonshow(true)
                dispatch(
                    setProfileData({
                        name: roleType === "superadmin" ? res.data.name : res.data.nameofInstitution,
                        phone: res.data.phoneNumber,
                        role: res.data.roleType,
                        price: res.data.adminPrice,
                        profileImage: roleType === "superadmin" ? res.data.profile_img : res.data.logo,
                        subexams: res.data.subexams,
                        exams: res.data.exams
                    })
                );

            } else {
                SafeToast.error(res?.message || "Update failed");
            }
        } catch (error) {
            console.error("Update error:", error);
            SafeToast.error("Something went wrong");
        }
    };

    useEffect(() => {
        fetchInitialData();
    }, []);

    useEffect(() => {
        let timer;
        if (otpCountdown > 0) {
            timer = setTimeout(() => setOtpCountdown(otpCountdown - 1), 1000);
        }
        return () => clearTimeout(timer);
    }, [otpCountdown]);
    const handleSendOtp = async () => {

        try {
            setIsSendingOtp(true);
            const res = await postWithTokenAPI(token, send_otp, {
                phoneNumber: phone,
                roleType: roleType
            });

            if (res?.statusCode === 200) {
                SafeToast.success("OTP sent successfully");
                setOtpCountdown(60);
                setShowOtpModal(true);
                // Focus first OTP input when modal opens
                setTimeout(() => {
                    if (otpInputRefs.current[0]) {
                        otpInputRefs.current[0].focus();
                    }
                }, 100);
            } else {
                SafeToast.error(res?.message || "Failed to send OTP");
            }
        } catch (err) {
            SafeToast.error(err?.response?.data?.message || "Failed to send OTP");
        } finally {
            setIsSendingOtp(false);
        }
    };

    const isValidPhone = (phone) => {
        const phoneRegex = /^[6-9]\d{9}$/;
        if (!phone) return false;
        if (!phoneRegex.test(phone)) return false;
        return true;
    };

    const handleVerifyOtp = async () => {
        const otpString = otp.filter(Boolean).join('');
        if (otpString.length !== 4) {
            SafeToast.error("Please enter a valid 4-digit OTP");
            return;
        }

        try {
            const res = await postWithTokenAPI(token, verify_otp, {
                phoneNumber: phone,
                otp: otpString,
                roleType: roleType
            });

            if (res?.statusCode === 200) {
                setIsOtpVerified(true);
                SafeToast.success("Phone number verified successfully");
                setsetOptbuttonshow(false)
                setTimeout(async () => {
                    try {
                        const updateRes = await putWithTokenAPI(token, `${update_profile}/${userId}`, {
                            phoneNumber: phone
                        });

                        if (updateRes?.statusCode === 200) {
                            SafeToast.success("Phone number updated successfully");
                            setShowOtpModal(false);
                            setOtp(["", "", "", ""]);
                            setIsOtpVerified(false);
                            setPhone("");
                        }
                    } catch (error) {
                        SafeToast.error("Failed to update phone number");
                    }
                }, 1500);
            } else {
                SafeToast.error(res?.message || "Invalid OTP");
                // Clear OTP on invalid
                setOtp(["", "", "", ""]);
                if (otpInputRefs.current[0]) {
                    otpInputRefs.current[0].focus();
                }
            }
        } catch (err) {
            SafeToast.error(err?.response?.data?.message || "OTP verification failed");
        }
    };
    const handleOtpChange = (index, value) => {
        if (!/^\d?$/.test(value)) return;

        setOtp((prev) => {
            const newOtp = [...prev];
            newOtp[index] = value;
            return newOtp;
        });

        // Auto focus next input
        if (value && index < 3) {
            otpInputRefs.current[index + 1]?.focus();
        }
    };

    const handleResendOtp = async () => {
        if (otpCountdown > 0) return;

        try {
            setIsSendingOtp(true);
            const res = await postWithTokenAPI(token, send_otp, {
                phoneNumber: phone,
                roleType: roleType
            });

            if (res?.statusCode === 200) {
                SafeToast.success("OTP resent successfully");
                setOtpCountdown(60);
                setOtp(["", "", "", ""]);
                if (otpInputRefs.current[0]) {
                    otpInputRefs.current[0].focus();
                }
            } else {
                SafeToast.error(res?.message || "Failed to resend OTP");
            }
        } catch (err) {
            SafeToast.error(err?.response?.data?.message || "Failed to resend OTP");
        } finally {
            setIsSendingOtp(false);
        }
    };

    // Handle OTP key down for backspace navigation
    const handleOtpKeyDown = (index, e) => {
        if (e.key === 'Backspace' && !otp[index] && index > 0) {
            otpInputRefs.current[index - 1]?.focus();
        }
    };

    const handleOtpPaste = (e) => {
        e.preventDefault();
        const pasteData = e.clipboardData
            .getData("text")
            .replace(/\D/g, "")
            .slice(0, 4);

        const newOtp = ["", "", "", ""];

        pasteData.split("").forEach((digit, i) => {
            newOtp[i] = digit;
        });

        setOtp(newOtp);

        // focus last filled input
        const lastIndex = pasteData.length - 1;
        if (otpInputRefs.current[lastIndex]) {
            otpInputRefs.current[lastIndex].focus();
        }
    };


    if (loading) {
        return (
            <div className="account-container">
                <InstitutionProfileSkeleton />
            </div>
        );
    }

    return (
        <div className="account-container">
            <div className="account-card-wrapper">
                {/* FORM SECTION */}
                <div className="form-grid-section">
                    <div className="upload-row">
                        <div className="upload-item">
                            <div className="logo-preview-circle">
                                {logo ? <img src={logo} alt="logo" /> : <div className="placeholder">LOGO</div>}
                                <div className="label-overlay">LOGO</div>
                            </div>
                            <label className="change-link">Change
                                <input
                                    type="file"
                                    hidden
                                    accept="image/*"
                                    onChange={(e) => handleImageChange(e, "logo")}
                                />
                            </label>
                        </div>

                        <div className="upload-item">
                            <div className="thumb-preview-box">
                                {thumbnail ? <img src={thumbnail} alt="thumb" /> : <div className="placeholder">160x195</div>}
                                <div className="label-overlay">THUMBNAIL</div>
                            </div>
                            <label className="change-link">Change
                                <input
                                    type="file"
                                    hidden
                                    accept="image/*"
                                    onChange={(e) => handleImageChange(e, "thumbnail")}
                                />
                            </label>
                        </div>

                        <div className="meta-inputs-container modern-glass-card">
                            <div className="input-group">
                                <label className="modern-label">Institution Description</label>
                                <textarea
                                    className="modern-textarea"
                                    value={description}
                                    onChange={(e) => setDescription(e.target.value)}
                                    style={{ '--focus-color': themeColor }}
                                    placeholder="Tell us about your institution..."
                                />
                            </div>

                            <div className="modern-color-section">
                                <label className="modern-label">Brand Identity</label>
                                <div className="modern-color-picker-pill">
                                    <div className="color-visual">
                                        <div className="color-circle" style={{ backgroundColor: themeColor }}>
                                            <input
                                                type="color"
                                                value={themeColor}
                                                onChange={(e) => setThemeColor(e.target.value)}
                                                className="hidden-color-input"
                                            />
                                        </div>
                                    </div>
                                    <div className="color-info">
                                        <span className="color-name">Theme Color</span>
                                        <span className="color-hex">{themeColor}</span>
                                    </div>
                                    <div className="color-action-text">Change</div>
                                </div>
                            </div>
                        </div>
                    </div>

                    <div className="inputs-container">
                        <div className="form-group">
                            <label>Phone Number</label>
                            <div className="input-box">
                                <span className="icon"><FiPhone /></span>
                                <input
                                    placeholder="Enter phone number"
                                    value={phone}
                                    type="tel"
                                    onChange={(e) => setPhone(e.target.value)}
                                    maxLength={10}
                                    disabled={setOptbuttonshow}
                                />
                                {
                                    setOptbuttonshow && (
                                        <button
                                            className="otp-btn"
                                            onClick={handleSendOtp}
                                        // disabled={!isValidPhone(phone) || isSendingOtp}
                                        >
                                            {isSendingOtp ? (
                                                <>
                                                    <span className="spinner"></span>
                                                    SENDING...
                                                </>
                                            ) : (
                                                "SEND OTP"
                                            )}
                                        </button>
                                    )
                                }

                            </div>
                        </div>

                        <div className="input-row">
                            <div className="input-field">
                                <label>Institution Name</label>
                                <input
                                    type="text"
                                    value={institution}
                                    onChange={(e) => setInstitution(e.target.value)}
                                />
                            </div>
                            <div className="input-field">
                                <label>State</label>
                                <Select
                                    styles={customStyles}
                                    options={stateOptions}
                                    value={selectedState}
                                    onChange={handleStateChange}
                                    placeholder="Select State"
                                />
                            </div>
                        </div>

                        <div className="input-row">
                            <div className="input-field">
                                <label>District</label>
                                <Select
                                    styles={customStyles}
                                    options={districtOptions}
                                    value={selectedDistrict}
                                    onChange={setSelectedDistrict}
                                    placeholder="Select District"
                                    isDisabled={!selectedState}
                                />
                            </div>
                            <div className="input-field">
                                <label>Exams</label>
                                {!showAddInput ? (
                                    <Select
                                        options={[...examOptions, { value: "ADD_NEW", label: "+ Add New" }]}
                                        value={selectedExams}
                                        onChange={handleExamsChange}
                                        placeholder="Search and select exams..."
                                        isMulti
                                        isClearable
                                        styles={customStyles}
                                        isSearchable
                                        closeMenuOnSelect={false}
                                    />
                                ) : (
                                    <div className="add-exam-row">
                                        <input
                                            type="text"
                                            value={newExamValue}
                                            onChange={(e) => setNewExamValue(e.target.value)}
                                            placeholder="Enter new exam"
                                            autoFocus
                                        />
                                        <button
                                            type="button"
                                            onClick={handleAddExam}
                                            className="add-btn"
                                        >
                                            Add
                                        </button>
                                        <button
                                            type="button"
                                            onClick={() => {
                                                setShowAddInput(false);
                                                setNewExamValue("");
                                            }}
                                            className="close-btn"
                                        >
                                            ✕
                                        </button>
                                    </div>
                                )}
                            </div>
                        </div>

                        <div className="input-row">
                            <div className="input-field">
                                <label>Bank Account No</label>
                                <input
                                    type="text"
                                    value={accountNo}
                                    onChange={(e) => setAccountNo(e.target.value)}
                                />
                            </div>
                            <div className="input-field">
                                <label>IFSC</label>
                                <input
                                    type="text"
                                    value={ifsc}
                                    onChange={(e) => setIfsc(e.target.value)}
                                />
                            </div>
                        </div>

                        <div className="input-row align-bottom">
                            {/* <div className="input-field">
                                <label>Bank</label>
                                <Select
                                    styles={customStyles}
                                    options={bankOptions}
                                    value={selectedBank}
                                    onChange={setSelectedBank}
                                    placeholder="Select Bank"
                                />
                            </div> */}
                            <div className="input-field">
                                <label>Bank</label>
                                <input
                                    type="text"
                                    value={selectedBank}
                                    onChange={(e) => setSelectedBank(e.target.value)}
                                />
                            </div>
                            <div className="button-field">
                                <button className="btn-update" onClick={HandleUpdate}>
                                    Update Action
                                </button>
                            </div>
                        </div>
                    </div>
                </div>

                <div className="preview-sticky-section">
                    <p className="preview-header">Preview</p>
                    <div className="card-mockup" style={{ background: `linear-gradient(180deg, ${themeColor} 0%, #000 100%)` }}>

                        <div className="card-body-thumb">
                            <div className="card-thumb">
                                {thumbnail && <img src={thumbnail} alt="thumb" />}
                            </div>
                            <div className="card-logo-box">
                                {logo ? <img src={logo} alt="logo" /> : <div className="logo-placeholder">L</div>}
                            </div>
                            <p className="card-tags">
                                {selectedExams.map(e => e.label).join(" | ") || "No exams selected"}
                            </p>
                            <p className="card-candidates">2500+ Candidates</p>
                            <div className="explore-pill">
                                <span>Explore More</span>
                                <div
                                    className="arrow-circle"
                                    style={{ backgroundColor: themeColor }}
                                >
                                    <FiArrowRight />
                                </div>
                            </div>
                            <div className="card-text-overlay">
                                <h2 className="card-inst-name">{institution}</h2>
                                <p className="card-footer-info">{description}</p>
                            </div>
                        </div>
                    </div>
                </div>
            </div>

            {/* Crop Modal */}
            {showCropModal && selectedImage && (
                <div className="modal-overlay">
                    <div className="crop-modal">
                        <div className="modal-header">
                            <h3>Crop Image</h3>
                            <button onClick={handleCancelCrop}><FiX /></button>
                        </div>
                        <div className="modal-body">
                            <div className="crop-container">
                                <ReactCrop
                                    crop={crop}
                                    onChange={setCrop}
                                    onComplete={setCompletedCrop}
                                    aspect={1}

                                >
                                    <img
                                        src={selectedImage}
                                        onLoad={(e) => onImageLoad(e.target)}
                                        alt="Crop"
                                    />
                                </ReactCrop>
                            </div>
                            <div className="crop-actions">
                                <button
                                    className="cancel-crop-btn"
                                    onClick={handleCancelCrop}
                                >
                                    Cancel
                                </button>
                                <button
                                    className="apply-crop-btn"
                                    onClick={handleCropComplete}
                                    disabled={!completedCrop}
                                >
                                    Apply Crop
                                </button>
                            </div>
                        </div>
                    </div>
                </div>
            )}

            {showOtpModal && (
                <div className="modal-overlay">
                    <div className="otp-modal">
                        <div className="modal-header">
                            <div className="modal-title-section">
                                <FiCheck className="modal-title-icon verified" />
                                <h3>Verify OTP</h3>
                            </div>
                            <button
                                className="close-modal"
                                onClick={() => {
                                    setShowOtpModal(false);
                                    setOtp(["", "", "", ""]);
                                }}
                                disabled={isOtpVerified}
                            >
                                <FiX />
                            </button>
                        </div>
                        <div className="modal-body">
                            <div className="otp-info">
                                <p>Enter the 4-digit verification code sent to</p>
                                <div className="otp-phone-number">+91 {phone}</div>
                            </div>

                            <div className="otp-box-container">
                                <p className="otp-label">Enter OTP</p>
                                <div className="otp-inputs-group" onPaste={handleOtpPaste}>
                                    {[0, 1, 2, 3].map((index) => (
                                        <input
                                            key={index}
                                            ref={(el) => (otpInputRefs.current[index] = el)}
                                            type="text"
                                            inputMode="numeric"
                                            pattern="[0-9]*"
                                            maxLength="1"
                                            value={otp[index]}
                                            onChange={(e) => handleOtpChange(index, e.target.value)}
                                            onKeyDown={(e) => handleOtpKeyDown(index, e)}
                                            className="otp-digit-input"
                                            autoFocus={index === 0}
                                            disabled={isOtpVerified}
                                        />
                                    ))}
                                </div>

                                {otpCountdown > 0 ? (
                                    <div className="otp-timer">
                                        Resend OTP in <span className="timer-count">{otpCountdown}s</span>
                                    </div>
                                ) : (
                                    <button
                                        className="resend-otp-link"
                                        onClick={handleResendOtp}
                                        disabled={isOtpVerified}
                                    >
                                        Resend OTP
                                    </button>
                                )}
                            </div>

                            {isOtpVerified ? (
                                <div className="verification-success">
                                    <FiCheck className="success-icon" />
                                    <span>Phone number verified successfully!</span>
                                </div>
                            ) : (
                                <div className="otp-actions">
                                    <button
                                        className="verify-otp-btn"
                                        onClick={handleVerifyOtp}
                                        disabled={otp.some(digit => digit === '')}
                                    >
                                        VERIFY OTP
                                    </button>
                                </div>
                            )}
                        </div>
                    </div>
                </div>
            )}
        </div>

    );
};

export default AccountsComponent;